<template>
<div>
  <el-row type="flex" justify="space-between" class="title-bar">
    <div>
      <w-perf-analysis-time-info v-show="dataType === dataTypeData.snmp.value" :ref="timeInfoRef" :checkDatetime="checkDatetime" @change="onTimeTypeChange" @reload="onCurrentDataReLoad"/>
      <w-perf-analysis-time-info v-show="dataType === dataTypeData.cli.value" :fixed-time-type="analysisTimeType.CURRENT.value" @reload="onCurrentDataReLoad"/>
    </div>
    <div class="vertical-center-box">
      <el-tooltip v-show="isCli" class="item" effect="dark" :content="ROUTING_CLI_RECOMMEND_MESSAGE" placement="bottom">
        <i class="fas fa-info-circle mr-r10 c-pointer"/>
      </el-tooltip>
      <el-radio-group class="mr-r10" v-model="tmpDataType" @change="onDataTypeChange">
        <el-radio :label="dataTypeData.snmp.value" >{{dataTypeData.snmp.label}}</el-radio>
        <el-radio :label="dataTypeData.cli.value">{{dataTypeData.cli.label}}</el-radio>
      </el-radio-group>
      <w-excecute-cli-script-button class="mr-r4" size="small" v-show="dataType === dataTypeData.cli.value" ref="cliScriptButton" :obj="selectedNode.obj" :active="active && dataType === dataTypeData.cli.value" @start-execute-script="cliLoading=true" @end-execute-script="completeExecuteScript"/>
      <w-header-search-button @click="onShowSearchToolButtonClick"></w-header-search-button>
    </div>
  </el-row>
  <el-table-wrapper v-show="dataType === dataTypeData.snmp.value" v-loading="snmpLoading" border :data="tableData" :columns="columns" :show-custom-header="true" :show-search-tool="showSearchTool" ref="table" style="width:100%;" :show-overflow-tooltip="true"
  :pagination="true" :column-default="columnDefault">
  </el-table-wrapper>
  <el-input v-show="dataType === dataTypeData.cli.value" v-loading="cliLoading" type="textarea" v-model="scriptResult" :autosize="{ minRows: 10 }" placeholder="스크립트를 수행해주세요."></el-input>
</div>
</template>
<script>
import isNil from 'lodash/isNil';
import { analysisTimeType } from '@/constants/performance';
import msgUtil from '@/utils/message';
import analysisTableMixin from '@/mixins/performance/analysis-table-ex';
import netdeviceTableInfoAPI from '@/api/performance/netdevice/netdevice-table-info';
import netdeviceRoutingViewMixin from '@/mixins/config/netdevice-routing-view';
import WPerfAnalysisTimeInfo from '@/views/performance/node/analysis/components/PerfAnalysisTimeInfo';
import WExcecuteCliScriptButton from '@/views/config/node/netdevice/components/ExcecuteCliScriptButton';

export default {
  name: 'WRoutingInfoTable',
  mixins: [analysisTableMixin, netdeviceRoutingViewMixin],
  components: {
    WPerfAnalysisTimeInfo,
    WExcecuteCliScriptButton,
  },
  data() {
    return {
      analysisTimeType,
    };
  },
  watch: {
    selectedNode: { // mixin override
      immediate: true,
      handler() {
        if (this.active) {
          this.dataType = null;
          this.clear();
          this.changeObjFlag = true;
        }
      },
    },
    dataType: {
      handler() {
        this.loadAnalysisTable();
      },
    },
  },
  methods: {
    /**
     * 데이터를 초기화한다.
     * @author Ju
     * @return {[type]} [description]
     */
    clear() {
      this.cliLoading = false;
      this.scriptResult = '';
      this.checkDatetime = null;
      this.tableData = [];
    },
    /**
     * 라우팅 데이터를 조회한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadData() {
      if (isNil(this.dataType)) {
        this.getRoutingSnapshotTypeOfObj(this.selectedNode.obj.objId);
      } else if (this.dataType === this.dataTypeData.snmp.value) {
        this.loadDataBySnmp();
      }
      // TODO: 품보팀 의견 확인. 이전에 수행된 스크립트가 잇는 경우는 무조건 수행하도록 할지 아니면 다음 경우에만 수행하도록 할지 의견 확인
      // CLI는 사용자가 '수행' 또는 새로 고침 (reload) 하는 경우에만 조회
    },
    reloadData() {
      if (isNil(this.dataType)) {
        this.getRoutingSnapshotTypeOfObj(this.selectedNode.obj.objId);
      } else if (this.dataType === this.dataTypeData.snmp.value) {
        this.loadDataBySnmp();
      } else {
        this.loadDataByCli();
      }
    },
    /**
     * SNMP를 통해 라우팅 정보를 조회한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadDataBySnmp() {
      const params = {
        objId: this.selectedNode.obj.objId,
      };
      if (this.timeType === analysisTimeType.HIST.value) {
        params.baselineDatetime = this.plotLineDatetime;
        params.managetypeId = 'NMS';
        this.snmpLoading = true;
        netdeviceTableInfoAPI.getRoutingInfoList(params).then((response) => {
          if (response.data.success === true) {
            const snapshotData = response.data.data;
            this.tableData = snapshotData.snapshotDoc;
            this.checkDatetime = snapshotData.timestamp;
          } else {
            this.failToLoad();
          }
        }).catch(() => {
          this.failToLoad();
        }).finally(() => {
          this.snmpLoading = false;
        });
      } else {
        this.snmpLoading = true;
        netdeviceTableInfoAPI.getCurrentRoutingInfoList(params).then((response) => {
          if (response.data.success === true) {
            this.tableData = response.data.data;
          } else {
            this.failToLoad();
          }
        }).catch(() => {
          this.failToLoad();
        }).finally(() => {
          this.snmpLoading = false;
        });
      }
    },
    /**
     * 데이터 로드 실패 처리
     * @author Ju
     * @return {[type]} [description]
     */
    failToLoad() {
      this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '라우팅 정보', false));
    },
    /**
     * 현재 데이터 reload 이벤트 핸들러 (override)
     * @author Ju
     * @return {[type]} [description]
     */
    onCurrentDataReLoad() {
      this.reloadData();
    },
    /**
     * 스크립트 수행 완료 이벤트 핸들러
     * @author Ju
     * @param  {[type]} success [description]
     * @param  {[type]} data    [description]
     * @param  {[type]} message [description]
     * @return {[type]}         [description]
     */
    completeExecuteScript(success, data, message) {
      this.cliLoading = false;
      if (success === true) {
        this.scriptResult = data;
        if (!isNil(message)) {
          this.$message(message);
        }
      } else if (success === false) {
        this.$message(msgUtil.getCustomResultMsgData(message, false));
      }
    },
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/netdevice/components/table/RoutingInfoTable.vue